import './App.css';
import {Grid} from "@mui/system";
import '@fontsource/plus-jakarta-sans/300.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/800.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/600.css';
import '@fontsource/roboto/700.css';
import Pagina from "./Pagina/Pagina";
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {createContext, useEffect, useState} from "react";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {collection, orderBy, query} from "firebase/firestore";
import {fire} from "./fire";

export const contexApp = createContext()


function App() {
    const [cargando, setCargando] = useState(false)
    const {data: categorias, actualizarDataLocal: actCategorias} = useObtenerDataActualizada({
        clave: 'categorias',
    })
    const {data: espacios, actualizarDataLocal: actEspacios} = useObtenerDataActualizada({
        clave: 'espacios',
    })
    const {data: politicas, actualizarDataLocal: actPoliticas} = useObtenerDataActualizada({
        clave: 'politicas',
    })
    const {data: blogs, actualizarDataLocal: actBlogs} = useObtenerDataActualizada({
        clave: 'blogs',
    })
    const {data: profesionales, actualizarDataLocal: actProfesionales} = useObtenerDataActualizada({
        clave: 'profesionales',
    })

    const valoresProvider = {
        categorias,
        espacios,
        politicas,
        blogs,
        profesionales,
    }

    const {Provider} = contexApp;


    useEffect(() => {

        //se verifica si esta o no actualizado

        obtenerFechaAct('categorias').then((dox) => {
            let w = []
            let q = query(collection(fire, 'categorias'), orderBy('prioridad', 'asc'))
            actCategorias({fecha: dox, wheres: w, query: q}).then()
        })

        obtenerFechaAct('espacios').then((dox) => {
            let w = []
            let q = query(collection(fire, 'espacios'), orderBy('fechaEspacio', 'asc'))
            actEspacios({fecha: dox, wheres: w, query: q}).then()
        })

        obtenerFechaAct('politicas').then((dox) => {
            let w = []
            let q = query(collection(fire, 'politicas'))
            actPoliticas({fecha: dox, wheres: w, query: q}).then()
        })

        obtenerFechaAct('blogs').then((dox) => {
            let w = []
            let q = query(collection(fire, 'blogs'))
            actBlogs({fecha: dox, wheres: w, query: q}).then()
        })

        obtenerFechaAct('profesionales').then((dox) => {
            let w = []
            let q = query(collection(fire, 'profesionales'))
            actProfesionales({fecha: dox, wheres: w, query: q}).then()
        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <h1 style={{display: 'none'}}>Charlas de temas Psicologicos</h1>
            <h2 style={{display: 'none'}}>Profesionales en salud mental</h2>
            <h2 style={{display: 'none'}}>Apoyo en salud mental</h2>
            <h2 style={{display: 'none'}}>Psicologos especializados</h2>
            <h2 style={{display: 'none'}}>Salud Mental</h2>

            <Provider value={valoresProvider}>
                <Pagina/>
            </Provider>

            {/*<Button
                loading={cargando}
                onClick={() => colocarPrioridades()}
            >
                Colocar prioridad
            </Button>*/}

        </Grid>
    );
}

export default App;
